import { createSlice } from "@reduxjs/toolkit";

type initialStateInterface = {
  flag: string,
};

const initialState: initialStateInterface = {
  flag: "",
};

const tokenFlagSlice = createSlice({
  name: "auth/tokenFlag",
  initialState: initialState,
  reducers: {
    setTokenFlag: (state, {payload}) => {
      return { flag: payload };
    },
    resetTokenFlag: (state) => {
      return { flag: "" };
    },
  }
});

export const { setTokenFlag, resetTokenFlag } = tokenFlagSlice.actions;

export default tokenFlagSlice.reducer;
